import React from 'react';
import {
  Defs,
  Rect,
  ClipPath,
  ForeignObject,
} from 'react-native-svg';
import { Vec2, vec2 } from 'utility/gl-matrix';

interface Props {
  uuid: string;
  size: Vec2;
  fetchAssetURL: (uuid: string) => Promise<string>;
}

export function AssetView(props: Props) {
  const [assetURL, setAssetURL] = React.useState<string | null>(null);
  const [isLoaded, setIsLoaded] = React.useState<boolean>(false);
  React.useEffect(() => {
    let wasCleanedUp = false;
    props.fetchAssetURL(props.uuid).then((url) => {
      if (wasCleanedUp) {
        return;
      }
      setAssetURL(url);
    });

    return () => {
      wasCleanedUp = true;
    };
  });

  if (assetURL == null) {
    return (
      <Rect
        {...vec2.toXY(vec2.create())}
        {...vec2.toSize(props.size)}
        rx={6 /* eyeballed */}
        ry={6}
        fill={'rgba(0, 0, 0, 0.15)'}
      />
    );
  } else {
    return (
      <>
      <Defs>
        <ClipPath
          id={`${props.uuid}.roundedCornersMask.clipPath`}
        >
          <Rect
            x={0}
            y={0}
            {...vec2.toSize(props.size)}
            rx={6 /* eyeballed */}
            ry={6}
          />
        </ClipPath>
      </Defs>
      <ForeignObject
        {...vec2.toSize(props.size)}
        {
          /* HACK: DOM-only - react-native-svg does not support clip-path on
           * foreignObject, but will pass the prop to the DOM element. */
          ...({clipPath: `url(#${props.uuid}.roundedCornersMask.clipPath)`}) as any
        }
      >
        {/* DOM-only (img) */}
        {/* eslint-disable jsx-a11y/alt-text */}
        <img
          onLoad={() => {
            setIsLoaded(true);
          }}
          src={assetURL}
          style={{
            width: '100%',
            height: '100%',
            ...(isLoaded ? {} : { backgroundColor: 'rgba(0, 0, 0, 0.15)'})
          }}
        />
        {/* eslint-enable jsx-a11y/img-redundant-alt */}
      </ForeignObject>
      </>
    );
  }
}

export default AssetView;
